(() => {
  const storageKey = 'crockeryTownMobileAppPrompt';
  const dismissalDays = 14;
  let deferredInstallPrompt = null;

  const isStandalone = () =>
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  const isMobile = () =>
    window.matchMedia('(max-width: 749px)').matches ||
    /Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent);

  const isIos = () =>
    /iPhone|iPad|iPod/i.test(window.navigator.userAgent) && !window.MSStream;

  const wasRecentlyDismissed = () => {
    try {
      const dismissedAt = Number(window.localStorage.getItem(storageKey));
      return dismissedAt && Date.now() - dismissedAt < dismissalDays * 86400000;
    } catch (error) {
      return false;
    }
  };

  const rememberDismissal = () => {
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      // The prompt can still close when private browsing blocks storage.
    }
  };

  const initialisePrompt = () => {
    const prompt = document.querySelector('[data-mobile-app-install]');
    if (!prompt || !isMobile() || isStandalone() || wasRecentlyDismissed()) return;

    const action = prompt.querySelector('[data-mobile-app-action]');
    const close = prompt.querySelector('[data-mobile-app-close]');
    const later = prompt.querySelector('[data-mobile-app-later]');
    const instructions = prompt.querySelector('[data-mobile-app-instructions]');
    let previouslyFocused = null;

    const hidePrompt = (remember = false) => {
      if (remember) rememberDismissal();
      prompt.hidden = true;
      document.documentElement.style.overflow = '';
      if (previouslyFocused) previouslyFocused.focus();
    };

    const showInstructions = () => {
      if (isIos()) {
        instructions.textContent =
          'On iPhone: tap the Share icon in Safari, then choose “Add to Home Screen”.';
      } else {
        instructions.textContent =
          'Open your browser menu (⋮), then choose “Add to Home screen” or “Install app”.';
      }
      instructions.hidden = false;
      action.textContent = 'Got it';
      action.dataset.instructionsVisible = 'true';
    };

    const showPrompt = () => {
      previouslyFocused = document.activeElement;
      prompt.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      close.focus();
    };

    action.addEventListener('click', async () => {
      if (action.dataset.instructionsVisible === 'true') {
        hidePrompt(true);
        return;
      }

      if (deferredInstallPrompt) {
        deferredInstallPrompt.prompt();
        await deferredInstallPrompt.userChoice;
        deferredInstallPrompt = null;
        hidePrompt(true);
        return;
      }

      showInstructions();
    });

    close.addEventListener('click', () => hidePrompt(true));
    later.addEventListener('click', () => hidePrompt(true));

    prompt.addEventListener('click', (event) => {
      if (event.target === prompt) hidePrompt(true);
    });

    prompt.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hidePrompt(true);
    });

    window.setTimeout(showPrompt, 4500);
  };

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
  });

  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null;
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      // No action required.
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePrompt, { once: true });
  } else {
    initialisePrompt();
  }
})();
